import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'

function Register() {
    const [user, setUser] = useState({
        name: '', email: '', password: '', telephone_number: '', address: ""
    })

    const onChangeInput = e => {
        const { name, value } = e.target;
        setUser({ ...user, [name]: value })
    }

    const registerSubmit = async e => {
        e.preventDefault()
        try {
            await axios.post('/user/register', { ...user });

            localStorage.setItem('firstLogin', true);

            window.location.href = "/";
        } catch (err) {
            alert(err.response.data.msg)
        }
    }

    return (
        <div className="login-page">
            <form onSubmit={registerSubmit}>
                <h2>Регистрация</h2>
                <input type="text" name="name" required
                    placeholder="Две имена" value={user.name} onChange={onChangeInput} />

                <input type="email" name="email" required
                    placeholder="Email" value={user.email} onChange={onChangeInput} />

                <input type="text" name="telephone_number" required
                    placeholder="Телефонен номер" value={user.telephone_number} onChange={onChangeInput} />

                <input type="text" name="address" required
                    placeholder="Адрес за доставка" value={user.address} onChange={onChangeInput} />

                <input type="password" name="password" required autoComplete="on"
                    placeholder="Парола" value={user.password} onChange={onChangeInput} />

                <div className="row">
                    <button type="submit">Регистрация</button>
                    <Link to="/login">Влез</Link>
                </div>
            </form>
        </div>
    )
}

export default Register